import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "balanceHeader" };
const _hoisted_4 = {
    key: 0,
    class: /*@__PURE__*/ _normalizeClass('hubItemWrapper')
};
const _hoisted_5 = { class: "bottom-buttons" };
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AccountButton from './elements/AccountButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SavingsCard from './elements/SavingsCard.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MyVouchersByMerchantPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCustomerVouchersSummary } = useVouchers();
        const savingsItems = computed(() => [
            {
                value: state.vouchersSummary.currentSavings,
                label: 'Saved to spend'
            },
            {
                value: state.vouchersSummary.savedThisMonth,
                label: 'Saved this month'
            },
            {
                value: state.vouchersSummary.allTimeSavings,
                label: 'All time savings'
            }
        ]);
        function onLoad() {
            getCustomer(() => {
                getCustomerVouchersSummary();
            });
        }
        function navigateToArchived() {
            router.push('/MyVouchers/Archived/Merchants');
        }
        function navigateToShopVouchers() {
            router.push('/shopvouchers');
        }
        function handleClick(merchant) {
            router.push('/MyVouchers/Merchants/' + merchant.merchantId + '?archive=false');
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(HeaderBlock, {
                        bgcolor: "#FCE5D4ff",
                        title: "Vouchers"
                    }),
                    _createVNode(CustomerLoadWait, {
                        customer: _unref(state).customer && _unref(state).vouchersSummary,
                        cardBlocks: true,
                        withTopCard: true
                    }, null, 8, ["customer"]),
                    (_unref(state).customer && _unref(state).vouchersSummary)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(SavingsCard, {
                                    items: savingsItems.value,
                                    formatter: _unref(state).formatter
                                }, null, 8, ["items", "formatter"])
                            ]),
                            _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).vouchersSummary.merchantGroups, (a) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass('hubItemWrapper'),
                                        key: a.id
                                    }, [
                                        _createVNode(AccountButton, {
                                            showProvider: false,
                                            onClick: ($event) => (handleClick(a)),
                                            title: a.merchantName,
                                            icon: a.customerVouchers[0].discount.cardUrl,
                                            balance: _unref(state).formatter.format(a.totalBalance),
                                            voucherCount: a.totalVouchers
                                        }, null, 8, ["onClick", "title", "icon", "balance", "voucherCount"])
                                    ]));
                                }), 128)),
                                (_unref(state).vouchersSummary.merchantGroups.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(AccountButton, {
                                            href: "/#/ShopVouchers",
                                            isAddButton: true
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("div", { style: { "clear": "both", "margin-bottom": "10px" } }, null, -1))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(MGButton, {
                        arrow: true,
                        text: "Shop Vouchers",
                        stacked: true,
                        fullWidth: true,
                        onClick: _cache[0] || (_cache[0] = ($event) => (navigateToShopVouchers()))
                    }),
                    _createVNode(MGButton, {
                        text: "Archived",
                        outline: true,
                        stacked: true,
                        fullWidth: true,
                        onClick: _cache[1] || (_cache[1] = ($event) => (navigateToArchived()))
                    })
                ])
            ]));
        };
    }
});
